var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2C2.22386 2 2 2.22386 2 2.5V21.5C2 21.7761 2.22386 22 2.5 22H3.5C3.77614 22 4 21.7761 4 21.5V18.75H8V20C8 21.1046 8.89543 22 10 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H10C8.89543 2 8 2.89543 8 4V5.25H4V2.5C4 2.22386 3.77614 2 3.5 2H2.5ZM8 6.75V17.25H4V6.75H8ZM11.2929 5.96828L14.355 4.17386C14.7505 3.94205 15.2495 3.94205 15.645 4.17386L18.7071 5.96828C18.8891 6.07493 19 6.26386 19 6.46736V11.414C19 11.7376 18.7245 12 18.3846 12H16.5385V9.94896C16.5385 9.13985 15.8497 8.48394 15 8.48394C14.1503 8.48394 13.4615 9.13985 13.4615 9.94896V12H11.6154C11.2755 12 11 11.7376 11 11.414V6.46736C11 6.26386 11.1109 6.07493 11.2929 5.96828ZM11 15.25H19C19.4142 15.25 19.75 15.5858 19.75 16C19.75 16.4142 19.4142 16.75 19 16.75H11C10.5858 16.75 10.25 16.4142 10.25 16C10.25 15.5858 10.5858 15.25 11 15.25ZM12.25 19C12.25 18.5858 12.5858 18.25 13 18.25H17C17.4142 18.25 17.75 18.5858 17.75 19C17.75 19.4142 17.4142 19.75 17 19.75H13C12.5858 19.75 12.25 19.4142 12.25 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelSign);
export default __webpack_public_path__ + "static/media/hotel-sign.c7df07af99173d887c017e0a652ec5d8.svg";
export { ForwardRef as ReactComponent };